/* eslint-disable no-negated-condition */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { HiTrash } from 'react-icons/hi';
import { IoMdAdd } from 'react-icons/io';
import { RiPencilFill } from 'react-icons/ri';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import Loader from 'components/common/Loader';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import { axiosGetAPI } from 'services';
import { authContext } from 'contexts/AuthContext';

const BannerList = ({
  toggleDeleteRecord,
  drawerToggle,
  isAdvt,
  listingType,
  promotionType,
}) => {
  const { auth } = useContext(authContext);
  const [bannerList, setBannerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBanners = useCallback(async () => {
    setLoading(true);
    const resp = await axiosGetAPI(
      `${process.env.REACT_APP_REST_API_ENDPOINT}banner-position`,
      auth,
    );
    if (resp?.status === 'success') {
      const items = resp?.data?.data || [];
      const filteredItems = items.filter((item) => {
        if (promotionType && item?.promotionType !== promotionType)
          return false;
        if (listingType && item?.listingType !== listingType) return false;
        if (isAdvt !== undefined && item?.isAdvt !== isAdvt) return false;
        if (item?.status && item?.status !== 'ACTIVE') return false;
        if (item?.deleted) return false;
        return true;
      });
      setBannerList(filteredItems);
      setError(null);
    } else {
      setBannerList([]);
      setError({ message: resp?.message || 'Unable to fetch banners' });
    }
    setLoading(false);
  }, [auth, isAdvt, listingType, promotionType]);

  useEffect(() => {
    fetchBanners();
  }, [fetchBanners]);

  const handleOpenLink = (url) => {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!bannerList) return <NoDataFound message="Data not available" />;
  return (
    <>
      <div className="text-end">
        <Button
          color="primary"
          className="text-nowrap end-0 top-0 position-absolute p-0 rounded-btn rounded-circle d-flex align-items-center justify-content-center"
          size="sm"
          onClick={() => drawerToggle('', ADD_EDIT_CONSTANT.ADD, fetchBanners)}
        >
          <IoMdAdd color="#fff" size={20} />
        </Button>
      </div>
      <Row>
        {bannerList?.length ? (
          bannerList.map((item) => {
            const linkTarget = item?.webImageUrl || item?.imageUrl;
            return (
              <Col key={item.id} xs={6} sm={6} md={3} className="mb-3 mb-xl-4">
                <Card
                  className="border-0 position-relative banner-card overflow-hidden"
                  key={item.id}
                >
                  <div className="banner-card-actions">
                    <Button
                      color="link"
                      className="text-decoration-none p-0 icon-btn bg-white"
                      onClick={(event) => {
                        event.stopPropagation();
                        drawerToggle(
                          item,
                          ADD_EDIT_CONSTANT.EDIT,
                          fetchBanners,
                        );
                      }}
                    >
                      <RiPencilFill />
                    </Button>
                    <Button
                      color="link"
                      onClick={(event) => {
                        event.stopPropagation();
                        toggleDeleteRecord(item, fetchBanners);
                      }}
                      className="text-decoration-none p-0 icon-btn text-black bg-white"
                    >
                      <HiTrash />
                    </Button>
                  </div>
                  <CardBody className="p-0 ">
                    <button
                      type="button"
                      className="banner-image-btn"
                      onClick={() => handleOpenLink(linkTarget)}
                    >
                      <img
                        src={item?.imageUrl}
                        alt="Banner"
                        className="banner-image"
                      />
                    </button>
                  </CardBody>
                </Card>
                <div className="f-12 fw-semibold pt-1">
                  {item?.promotionType || 'Banner'}
                </div>
                {linkTarget && (
                  <div className="f-12 text-truncate">
                    <a href={linkTarget} target="_blank" rel="noreferrer">
                      {linkTarget}
                    </a>
                  </div>
                )}
              </Col>
            );
          })
        ) : (
          <Col sm={12} className="no-data-column">
            <NoDataFound message="Banner data not available!" />
          </Col>
        )}
      </Row>
    </>
  );
};

export default BannerList;
